import { connect } from "react-redux";
import Draggable from "react-draggable";
import { TailSpin } from "react-loader-spinner";

import { EMPTY_STRING } from "../../../constants";
import { useScreenWidth, useScreenHeight } from "../../hooks/windowResize";

const DraggableNotification = ({
  isInventoryImporting,
  draggableNotification,
}) => {
  const [screenWidth] = useScreenWidth();
  const [screenHeight] = useScreenHeight();

  const messages = draggableNotification?.messages || [];
  const isImportVisible = isInventoryImporting?.isVisible;

  const getDimensions = (msg = EMPTY_STRING) => {
    return msg.length < 30
      ? { width: 220, height: 70 }
      : { width: 280, height: 110 };
  };

  const handleBounds = (width, height) => ({
    left: 10,
    top: 10,
    right: screenWidth - width,
    bottom: screenHeight - height,
  });

  const renderDraggable = (message) => {
    const { width, height } = getDimensions(message);

    return (
      <Draggable
        key={message}
        handle=".draggable-notification"
        bounds={handleBounds(width, height)}
        defaultPosition={{
          x: screenWidth - width,
          y: screenHeight - height,
        }}
      >
        <div className="draggable-notification d-flex justify-content-center align-items-center gap-3">
          <TailSpin color="#6a18ed" height={25} width={25} strokeWidth={4} />
          <p className="m-0">{message}</p>
        </div>
      </Draggable>
    );
  };

  if (isImportVisible) {
    return renderDraggable(isInventoryImporting.message);
  }

  return <>{messages.map((msg) => renderDraggable(msg.message))}</>;
};

const mapStateToProps = (state) => ({
  draggableNotification: state.system.draggableNotification,
  isInventoryImporting: state.inventory.isInventoryImporting,
});

export default connect(mapStateToProps)(DraggableNotification);
